import { ComponentAction, NativeFeatureIdentifier } from '@standardnotes/features';
import { ContentType } from '@standardnotes/domain-core';
export const ReadwriteActions = [
    ComponentAction.SaveItems,
    ComponentAction.CreateItem,
    ComponentAction.CreateItems,
    ComponentAction.DeleteItems,
    ComponentAction.SetComponentData,
];
/**
 * Extensions allowed to batch stream AllowedBatchContentTypes
 */
export const AllowedBatchStreaming = Object.freeze([
    NativeFeatureIdentifier.TYPES.LegacyFileSafeIdentifier,
    NativeFeatureIdentifier.TYPES.DeprecatedFileSafe,
    NativeFeatureIdentifier.TYPES.DeprecatedBoldEditor,
]);
/**
 * Content types which are allowed to be managed/streamed in bulk by a component.
 */
export const AllowedBatchContentTypes = Object.freeze([
    ContentType.TYPES.FilesafeCredentials,
    ContentType.TYPES.FilesafeFileMetadata,
    ContentType.TYPES.FilesafeIntegration,
]);
